import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronLeft, FaChevronRight, FaChevronUp } from "react-icons/fa";
import "./Sidebar.css";

function Sidebar({ activeTab, onNavigate, collapsed, onToggle, mobileOpen, onMobileClose, items }) {
  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleGroup = (groupId) => {
    setExpandedGroups((previous) => ({ ...previous, [groupId]: !previous[groupId] }));
  };

  const getRoute = (item) => item?.route || item?.id || "";

  const isActive = (item) => {
    if (item.children) {
      return item.children.some((child) => {
        const childRoute = getRoute(child).split("?")[0];
        const currentPath = activeTab.split("?")[0];
        if (childRoute === "/tools") {
          return currentPath === "/tools";
        }
        return activeTab.startsWith(childRoute);
      });
    }

    const route = getRoute(item);
    if (route.includes("?")) {
      return activeTab === route;
    }

    return activeTab.split("?")[0] === route.split("?")[0];
  };

  const isChildActive = (child) => {
    const route = getRoute(child);
    if (route.includes("?")) {
      return activeTab === route;
    }
    return activeTab.split("?")[0] === route.split("?")[0];
  };

  return (
    <>
      {mobileOpen && <div className="sidebar-overlay" onClick={onMobileClose} />}

      <aside className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-brand">
          <Link to="/" className="brand-link">
            <img src="/assets/Logo.jpg" alt="Heel logo" className="sidebar-logo" />
            <span className="sidebar-app-title">The Heel Portal</span>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {items.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            const hasChildren = item.children && item.children.length > 0;
            const isExpanded = expandedGroups[item.id] || active;
            const itemRoute = getRoute(item);

            return (
              <div key={item.id} className="sidebar-group">
                <button
                  className={`sidebar-item ${active ? "active" : ""}`}
                  onClick={() => {
                    if (hasChildren) {
                      toggleGroup(item.id);
                    } else if (itemRoute) {
                      onNavigate(itemRoute);
                      if (mobileOpen) onMobileClose();
                    }
                  }}
                  title={collapsed ? item.label : undefined}
                >
                  <span className="sidebar-icon">
                    <Icon />
                  </span>
                  <span className="sidebar-label">{item.label}</span>
                  {hasChildren && !collapsed && (
                    <span className="sidebar-chevron">
                      {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  )}
                </button>

                {hasChildren && isExpanded && !collapsed && (
                  <div className="sidebar-children">
                    {item.children.map((child) => {
                      const ChildIcon = child.icon;
                      const childActive = isChildActive(child);
                      const childRoute = getRoute(child);

                      return (
                        <button
                          key={child.id}
                          className={`sidebar-child ${childActive ? "active" : ""}`}
                          onClick={() => {
                            if (childRoute) {
                              onNavigate(childRoute);
                              if (mobileOpen) onMobileClose();
                            }
                          }}
                        >
                          <span className="sidebar-child-icon">
                            <ChildIcon />
                          </span>
                          <span className="sidebar-label">{child.label}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        <button
          className="sidebar-toggle"
          onClick={onToggle}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>

        <div className="sidebar-footer">
          <div className="sidebar-divider" />
          <div className="sidebar-version">
            <span className="sidebar-label">v1.0</span>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
